import { render } from "./SkeletonBaseSummaryList.vue?vue&type=template&id=01f6a277"
import script from "./SkeletonBaseSummaryList.vue?vue&type=script&lang=js"
export * from "./SkeletonBaseSummaryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__